import React, {memo, RefObject, useCallback, useMemo} from "react";
import styles from "./CommentCard.module.css";
import {Label12, Text16} from "../../../../../common/components/typography/Typography";
import {ParentComponentProps} from "../../../../../common/ParentComponentProps";
import {
    stringifyVideoTimeWithColons,
    stringifyVideoTimeAgo
} from "../../../../../common/video/util/videoTimeStrings";
import {VideoComment} from "../../../../../common/video/models/VideoComment";
import videoApi from "../../../../../common/video/VideoApi";
import {useSelector} from "react-redux";
import {AppState} from "src/root/RootReducer";
import {isAdmin} from "src/utils/LogicUtils";

interface CommentProps {
    comment: VideoComment;
    videoRef: RefObject<HTMLVideoElement>;
}

function CommentCard({comment, videoRef}: CommentProps) {
    const handleClick = useCallback(() => {
        if (videoRef && videoRef.current) {
            videoRef.current.currentTime = comment.commentTimeMillis / 1000;
        }
    }, [comment, videoRef]);

    const delComment = () => {
        videoApi.delCommentToVideo(comment.videoId,comment.id).then(() => {
            window.location.reload();
        });
    };

    const {userInfo} = useSelector(
        (state: AppState) => ({
            userInfo: state.user.userInfo
        })
    );

    const canDeleteComment = useMemo(() => {
        return !(typeof comment.id === "string" && comment.id.startsWith("_temp_id")) 
        && (isAdmin(userInfo?.roles) || userInfo.id === comment.userId);
    },[comment.id, comment.userId, userInfo.id, userInfo?.roles]);


    return (
        <div className={styles.commentCard} onClick={handleClick}>
            {canDeleteComment && <button
                className={styles.deleteButton}
                onClick={(e) => {
                    e.stopPropagation();
                    delComment();
                }}
            >
            ✕
            </button>}
            <div className={styles.meta}>
                <CommentMetaItem>
                    <Label12 color="gray-42" >
                        <span>{comment.fullName}</span>
                    </Label12>
                </CommentMetaItem>
                <CommentMetaItem>
                    <Label12 color="gray-42">
                        @ {stringifyVideoTimeWithColons(comment.commentTimeMillis)}
                    </Label12>
                </CommentMetaItem>
                <CommentMetaItem>
                    <Label12 color="gray-42">
                        {stringifyVideoTimeAgo(comment.created)}
                    </Label12>
                </CommentMetaItem>
            </div>

            <div className={styles.body}>
                <Text16>{comment.text}</Text16>
            </div>
        </div>
    );
}

function CommentMetaItem({children}: ParentComponentProps) {
    return (
        <div className={styles.metaItem}>
            {children}
        </div>
    );
}

export default memo(CommentCard);
